import {
  Document,
  Image,
  Font,
  Page,
  Text,
  View,
  StyleSheet,
} from "@react-pdf/renderer";

import PoppinsExtraBold from "fonts/Poppins-ExtraBold.ttf";
import PoppinsMedium from "fonts/Poppins-Medium.ttf";
import PoppinsRegular from "fonts/Poppins-Regular.ttf";

Font.register({
  family: "Poppins",
  fonts: [
    { src: PoppinsExtraBold, fontWeight: 900 },
    { src: PoppinsMedium, fontWeight: 500 },
    { src: PoppinsRegular, fontWeight: 400 },
  ],
});

// 100mm / 60mm
const InstructionLabel = ({
  data: {
    name,
    name_en,
    name_de,
    producer_code,
    part_number,
    quantity,
    barcode,
    qr_code,
    supplier_part_number,
  },
}) => (
  <Document>
    {Array.from({ length: quantity })
      .fill(null)
      .map((_, index) => (
        <Page
          key={index}
          size={{
            width: 283.465, // 100 mm
            height: 170.079, // 60 mm
          }}
          style={styles.page}
        >
          <View style={styles.name_group}>
            <Text style={styles.name_lang}>PL</Text>
            <Text style={styles.name_text}>{name}</Text>
          </View>
          <View style={styles.name_group}>
            <Text style={styles.name_lang}>DE</Text>
            <Text style={styles.name_text}>{name_de}</Text>
          </View>
          <View style={styles.name_group}>
            <Text style={styles.name_lang}>EN</Text>
            <Text style={styles.name_text}>{name_en}</Text>
          </View>
          <View style={styles.name_group}>
            <Text style={styles.name_label}>
              Kod produktu / Produktcode / Product code:
            </Text>
            <Text style={styles.name_text}>{producer_code}</Text>
          </View>
          <View style={styles.name_group}>
            <Text style={styles.name_label}>
              Numer partii / Chargennummer / Batch number:
            </Text>
            <Text style={styles.name_text}>{part_number}</Text>
          </View>
          {supplier_part_number && (
            <View style={styles.name_group}>
              <Text style={styles.name_label}>
                Numer partii dostawcy / Chargennummer / Supplier batch number:
              </Text>
              <Text style={styles.name_text}>{supplier_part_number}</Text>
            </View>
          )}
          {qr_code ? (
            <View style={styles.box}>
              <View style={styles.box_qr}>
                <Image src={qr_code} style={styles.qr_code} />
                <View style={styles.box_qr_text}>
                  <Text style={styles.box_qr_text_label}>
                    Instrukcja obsługi / Bedienungsanleitung / User manual
                  </Text>
                  <View style={styles.box_qr_text_group}>
                    <Image
                      style={styles.box_qr_text_group_image}
                      src="data:image/png;base64,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"
                    />
                    <Text style={styles.box_qr_text_group_text}>
                      Zeskanuj kod QR / QR-Code scannen / Scan the QR code
                    </Text>
                  </View>
                </View>
              </View>
              <Image src={barcode} style={styles.barcode} />
            </View>
          ) : (
            <View style={styles.box_center}>
              <Image src={barcode} style={styles.barcode} />
            </View>
          )}
        </Page>
      ))}
  </Document>
);

export default InstructionLabel;

const styles = StyleSheet.create({
  page: {
    backgroundColor: "#fff",
    padding: 0,
  },
  name_group: {
    flexDirection: "row",
    alignItems: "flex-start",
    marginBottom: 1.5,
  },
  name_lang: {
    width: 20,
    fontFamily: "Poppins",
    fontWeight: 900,
    fontSize: "6.5px",
  },
  name_label: {
    width: 172,
    fontFamily: "Poppins",
    fontWeight: 900,
    fontSize: "6.5px",
  },
  name_text: {
    flex: 1,
    fontFamily: "Poppins",
    fontWeight: 500,
    fontSize: "7px",
  },
  box: {
    marginTop: "auto",
    flexDirection: "row",
    alignItems: "center",
    gap: 5,
  },
  box_center: {
    marginTop: "auto",
    alignItems: "center",
    justifyContent: "center",
  },
  box_qr: {
    flex: 1,
    flexDirection: "row",
    alignItems: "center",
  },
  box_qr_text: {
    flex: 1,
    gap: 5,
  },
  box_qr_text_label: {
    fontFamily: "Poppins",
    fontWeight: 900,
    fontSize: "6.5px",
  },
  box_qr_text_group: {
    flexDirection: "row",
    alignItems: "center",
    gap: 5,
  },
  box_qr_text_group_image: {
    width: 30,
    height: 9,
  },
  box_qr_text_group_text: {
    flex: 1,
    fontFamily: "Poppins",
    fontWeight: 400,
    fontSize: "6px",
  },
  qr_code: {
    width: 55,
    height: 55,
    padding: 0,
    marginLeft: -8,
    marginTop: 2,
  },
  barcode: {
    height: 45,
  },
});
